<template>
    <!--
          作者：luoyiming
          时间：2019-10-24
          描述：后台母版
      -->
    <div :class="hasChild != null ? 'main' : 'main right-big'" class="app-main">
        <!--left menu-->
        <LeftMenu @selectMenu="selectMenuFunc"></LeftMenu>

        <!--right content-->
        <RightContent></RightContent>

        <!-- ai助理 -->
<!--        <AiAssistent></AiAssistent>-->
    </div>
</template>

<script>
import LeftMenu from '@/views/layout/LeftMenu.vue';
import RightContent from '@/views/layout/RightContent.vue';
import AiAssistent from './aiAssistent/aiAssistent.vue';
import store from '@/store/';
import {delCookie} from '@/utils/base.js';
import SupplierApi from '@/api/supplier.js';
import bus from '@/utils/eventBus.js';
import {setCurrentStore} from "../../logic/supplier";

export default {
    components: {
        /*左菜单组件*/
        LeftMenu,
        /*右边内容容器*/
        RightContent,
        // AI助理
        AiAssistent,
    },
    data() {
        return {
            /*是否有子菜单*/
            hasChild: null,
            /*系统基本数据*/
            baseInfo: {
                shop_name: '',
                supplier_name: '',
                user: {
                    user_type: null
                },
                version: '',
              expire_time: '',
              app_type: '',
            }
        };
    },
    provide: function () {
        return {
            baseInfo: this.baseInfo
        };
    },
    created() {
        if (this.$route.query.from && this.$route.query.from == 'admin') {
            delCookie('baseInfo');
        }

        this.getBaseInof();
    },
    methods: {
        /*左边子组件传来的参数*/
        selectMenuFunc(param) {
            this.hasChild = param;
        },

        async getBaseInof() {
            let res = await store.dispatch('common/getBaseInfo');
            this.baseInfo.shop_name = res.shop_name;
            this.baseInfo.supplier_name = res.supplier_name;
            this.baseInfo.version = res.version;
            this.baseInfo.user = res.user;
            this.baseInfo.app_type = res.app_type;
            this.baseInfo.expire_time = res.expire_time;
        }
    },
    async mounted() {
        console.log(this.$route.name)
        // 初始先加载当前的门店
        if (this.$route.name !== '_supplier_supplier_index') {
            await setCurrentStore()
            bus.$emit('updateStoreCallback')
        } else {
            // bus.$emit('')
        }
    }
};
</script>

<style>
.app-main {
    display: flex;
    justify-content: left;
    width: 100vw;
    height: 100vh;
    /*min-width: 500px;*/
    /*overflow-x: auto;*/
}
</style>



// WEBPACK FOOTER //
// src/views/layout/main.vue